import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'

@createActions(alt)
export default class NpsActions {
  constructor() {
    this.generateActions(
      'setDismissed',
      'setScore'
    )
  }

  dismiss() {
    this.setDismissed(true)
  }

  setScore(score) {
    this.setScore(score)
  }
}



// WEBPACK FOOTER //
// ./app/actions/NpsActions.js